import { uiSize } from '@utils'

interface Props {
  color?: string
}

function ExchangeIcon({ color = 'currentColor' }: Props) {
  return (
    <svg
      width={uiSize(14)}
      height={uiSize(14)}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='2.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M4 8h14l-3.5-3.5M20 16H6l3.5 3.5' />
    </svg>
  )
}

export default ExchangeIcon
